import React from "react";
import lang from "translations";
import { HeaderC } from "components/headers";
import { Path } from "paths";
import { Pill, TabBar, Title } from "components/commons";
import { PillType } from "enums";

const lifecycleStatusPillType = (status) => {
  switch ((status || "").toUpperCase()) {
    case "CLOSED":
    case "PAID":
    case "COMPLETED":
      return PillType.Green;
    case "VOIDED":
    case "CANCELLED":
      return PillType.Red;
    default:
      return PillType.Yellow;
  }
};

const ReservationDetailsHeader = ({ data, loading, id }) => {
  const reservation = data?.reservation || {};

  const tabItems = [
    { to: Path.RESERVATION_OVERVIEW_NAV(id), text: lang.reservationOverview },
    { to: Path.RESERVATION_ORDERS_NAV(id), text: lang.reservationOrders },
    { to: Path.RESERVATION_BILLING_NAV(id), text: lang.reservationBilling },
  ];

  return (
    <>
      <HeaderC
        loading={loading}
        customTitle={
          <div className="flex items-center gap-3">
            <Title xl className="font-semibold">
              {lang.reservation} #{reservation.posReservationId}
            </Title>
            <Pill size="text-xs" type={lifecycleStatusPillType(reservation.status)}>
              {reservation.status || "-"}
            </Pill>
          </div>
        }
        customDescription={
          <p className="text-sm">
            {lang.openedAt} <strong className="text-sm">{reservation.openedAt ?? "-"}</strong>
            {" · "}
            {lang.closedAt} <strong className="text-sm">{reservation.closedAt ?? "-"}</strong>
          </p>
        }
        returnText={lang.reservations}
        returnPath={Path.RESERVATION_LIST}
      />
      <TabBar className="mb-md" items={tabItems}></TabBar>
    </>
  );
};

export default ReservationDetailsHeader;
